var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.89355 8.59961H19.5146C19.7261 8.59977 19.8914 8.76853 19.8994 8.96973L19.8936 9.05762L17.8057 20.0859C17.7712 20.2681 17.6121 20.4004 17.4268 20.4004H3.98145C3.81917 20.4004 3.67712 20.2987 3.62109 20.1514L3.60254 20.0859L1.51465 9.05762C1.46971 8.82016 1.65193 8.5998 1.89355 8.59961Z","stroke":"currentColor","strokeWidth":"1.2","key":0}),React.createElement("path",{"d":"M14.6207 17C14.6207 17 15.5965 1 10.7 1C5.80338 1 6.7792 17 6.7792 17","stroke":"currentColor","strokeWidth":"1.2","key":1})]);
}

Cart.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Cart;

Cart.default = Cart;
